import React from 'react'
import moment from "moment";
import PaginationComponent from '../common/PaginationComponent';
import { useSelector } from 'react-redux';

const GameHistory = (props) => {
    const { currentPage, setCurrentPage } = props

    let PageSize = 10;
    const { betHistoryData, totalRecords, records } = useSelector(
        (state) => state?.betHistory
    );

    const bethistRecords = totalRecords + records;
    const sortedBetHistoryData = betHistoryData?.length > 0
        ? [...betHistoryData].sort((a, b) => new Date(b.placedDate) - new Date(a.placedDate))
        : [];

    const getStakeLabel = (placeBetType) => {
        if (placeBetType === "CASH_BET") {
            return "Stake";
        } else if (placeBetType === "FREE_SPIN") {
            return "Free Bet";
        } else {
            return "Unlocked Bonus";
        }
    };

    return (
        <>
            <div className="SB-betHistory-liveCasino">
                <div className="SB-myBetsBox-group">
                    {sortedBetHistoryData?.length > 0 ? (
                        sortedBetHistoryData?.map((btd) => {
                            return (
                                <div className="SB-betBox SB-gameBet" key={btd?.betId}>
                                    <div className="SB-betBox-header">
                                        <div className="SB-contentBlock">
                                            <div className="SB-leftContent">
                                                <span className="SB-betType">
                                                    {btd?.gameName}
                                                </span>
                                            </div>
                                            <div className="SB-rightContent">
                                                <span
                                                    className={`SB-badge ${btd?.betStatus === "Lost"
                                                        ? "SB-lost"
                                                        : btd?.betStatus === "Won"
                                                            ? "SB-won"
                                                            : ""
                                                        }`}
                                                >
                                                    {btd?.betStatus}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="SB-betBox-betStatusDetails">
                                        <div className="SB-contentBlock">
                                            <div className="SB-leftContent">
                                                <div className="SB-betID">ID: {btd?.betId}</div>
                                            </div>
                                        </div>
                                        <div className="SB-placedOnDate">
                                            Placed on:{" "}
                                            {`${moment(btd?.placedDate).format(
                                                "DD MMM"
                                            )} at ${moment(btd?.placedDate).format("HH:mm")}`}
                                        </div>
                                    </div>
                                    <div className="SB-betBox-stakeRetuns">
                                        <div className="SB-contentBlock">
                                            <div className="SB-leftContent">
                                                <span className="SB-label">{getStakeLabel(btd?.placeBetType)}:</span>
                                                <span className="SB-value">{`${btd?.currencyCode?.toUpperCase()} ${btd?.stake}`}</span>
                                            </div>
                                        </div>
                                        <div className="SB-contentBlock SB-stakeafterTax">
                                            <div className="SB-rightContent">
                                                <span className="SB-label">To Payout: </span>
                                                <span className="SB-value">{`${btd?.currencyCode?.toUpperCase()} ${btd?.payout?.toFixed(2)}`}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="SB-msgBox">
                            <div className="SB-msgBox-container">
                                Currently there is no data available
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {sortedBetHistoryData?.length > 0 && (
                <PaginationComponent
                    currentPage={currentPage}
                    totalCount={bethistRecords || 0}
                    pageSize={PageSize}
                    onPageChange={(page) => setCurrentPage(page)}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </>
    )
}

export default GameHistory